import { CancelType } from '@/enums/CancelType.enum';
import { SubmitType } from '@/enums/SubmitType.enum';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';

@Component({
    selector: 'app-modal-base',
    templateUrl: './modal-base.component.html',
    styleUrls: ['./modal-base.component.scss'],
    standalone: true,
    imports: [MatDialogModule, NgIf, MatButtonModule, MatIconModule, MatProgressSpinnerModule, TranslateModule, TooltipDirective]
})
export class ModalBaseComponent implements OnInit {
  @Input() title: string;
  @Input() titleParams: any = {};
  @Input() hasFooter = true;
  @Input() hasSubmit = true;
  @Input() hasCancel = true;
  @Input() isDraggable = true;
  @Input() loading = false;
  @Input() showLoading = true;
  @Input() isCurrencyMandatory = false;
  @Input() submitText = SubmitType.VALIDATE;
  @Input() isDisabled = false;
  @Input() cancelType = CancelType.CANCEL;
  @Input() isCancelDisabled = false;
  @Input() defaultCloseValue = false;
  @Output() onSubmitEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  cancelText: 'cancel' | 'close' = 'cancel';

  constructor() {}

  ngOnInit(): void {
    this.setCancelText();
  }

  onSubmit(): void {
    if (!this.isDisabled) {
      this.onSubmitEvent.next(true);
    }
  }

  setCancelText() {
    switch (this.cancelType) {
      case CancelType.CANCEL:
        this.cancelText = 'cancel';
        break;
      case CancelType.CLOSE:
        this.cancelText = 'close';
        break;
      default:
        this.cancelText = 'cancel';
        break;
    }
  }
}
